import React, { useState } from "react";
import { adminLogin } from "../lib/admin";
import { Lock } from "lucide-react";

export default function AdminLogin({ onLogin }) {
    const [u, setU] = useState("");
    const [p, setP] = useState("");
    const [err, setErr] = useState("");
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setErr("");
        setBusy(true);
        try {
            // Cookie is set by the backend response; we don't store the token in JS.
            await adminLogin(u, p);
            onLogin();
        } catch (er) {
            setErr(er?.response?.data?.detail || "Login failed");
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="min-h-[80vh] flex items-center justify-center px-4" data-testid="admin-login">
            <form
                onSubmit={submit}
                className="w-full max-w-md bg-slate-900/40 border border-white/10 p-8"
            >
                <div className="flex items-center gap-3 mb-6">
                    <span className="w-10 h-10 flex items-center justify-center border border-gold text-gold">
                        <Lock className="w-4 h-4" />
                    </span>
                    <div>
                        <div className="text-[10px] uppercase tracking-[0.3em] text-gold">Mission control</div>
                        <div className="font-serif text-2xl">Admin sign in</div>
                    </div>
                </div>
                <label className="block mb-4">
                    <span className="block text-[10px] uppercase tracking-[0.2em] text-slate-500 mb-1">
                        Username
                    </span>
                    <input
                        data-testid="admin-username"
                        autoFocus
                        value={u}
                        onChange={(e) => setU(e.target.value)}
                        className="w-full bg-slate-950 border border-white/10 px-3 py-3 text-sm font-mono focus:border-gold focus:outline-none"
                    />
                </label>
                <label className="block mb-6">
                    <span className="block text-[10px] uppercase tracking-[0.2em] text-slate-500 mb-1">
                        Password
                    </span>
                    <input
                        data-testid="admin-password"
                        type="password"
                        value={p}
                        onChange={(e) => setP(e.target.value)}
                        className="w-full bg-slate-950 border border-white/10 px-3 py-3 text-sm font-mono focus:border-gold focus:outline-none"
                    />
                </label>
                {err && (
                    <div
                        data-testid="admin-login-error"
                        className="text-xs font-mono text-red-400 mb-4 border border-red-400/30 bg-red-400/10 px-3 py-2"
                    >
                        {err}
                    </div>
                )}
                <button
                    data-testid="admin-login-submit"
                    type="submit"
                    disabled={busy}
                    className="w-full btn-sharp bg-white text-obsidian px-4 py-3 text-xs hover:bg-slate-200 disabled:opacity-50"
                >
                    {busy ? "Authenticating…" : "Enter mission control"}
                </button>
                <p className="text-[10px] font-mono text-slate-500 mt-4 leading-relaxed">
                    Authorized personnel only. Session lasts 24h.
                </p>
            </form>
        </div>
    );
}
